import {createOnlineAutomatically} from 'constants/url';
import {AddWith2ParamsOptions} from '../../../components/grid-dx/types';
import authFetch from '../../../helpers/requests';
import {useSelector} from 'react-redux';

function useAddOnlineAutomatically() {
  const addOnline = useAddWith2ParamsOptions(createOnlineAutomatically);
  return (addWith2ParamsOptions: AddWith2ParamsOptions) =>
    addOnline(addWith2ParamsOptions);
}

function useAddWith2ParamsOptions(url: string) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (addWith2ParamsOptions: AddWith2ParamsOptions) => {
    let options = new URLSearchParams();
    options.append('id', JSON.stringify(addWith2ParamsOptions.AddedOne));
    try {
      const response = await authFetch(
        `${url}?${options}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(
            JSON.stringify(addWith2ParamsOptions.AddedThree),
          ),
        },
        token,
      );
      return response;
    } catch (e) {
      return {};
    }
  };
}

export default useAddOnlineAutomatically;
